import React, {FC, useRef, useState} from 'react';

import {useSelectedConversationsDetails} from '../../../../libs/inboxes/business/src/cells/conversations';
import {KeyboardActionsEnum} from '../../../../libs/shared/core/src/helpers/browser/keyboardHelpers';
import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {CellsContext} from '../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {DropdownBox} from '../../../../libs/shared/ui/src/components/boxedInputs/dropdownBox';
import {ConversationBaseModel} from '../../../models/api/conversationModel';
import {OpenStatusEducationTipCoordinator} from '../../onboarding/sandbox/educationTips/openStatusEducationTipCoordinator';
import {ResolvedStatusEducationTipCoordinator} from '../../onboarding/sandbox/educationTips/resolvedStatusEducationTipCoordinator';
import {TicketStatusCell} from '../ticketing/ticketStatusCell';
import {ConversationTicketStatusCoordinator} from '../viewer/conversation/actions/ticketStatus/conversationTicketStatusCoordinator';

/*
 * Props.
 */

interface InboxesTopbarTicketStatusProps {
  cellsContext: CellsContext;
  conversations: ReadonlyArray<ConversationBaseModel>;
}

/*
 * Component.
 */

export const InboxesTopbarTicketStatus: FC<InboxesTopbarTicketStatusProps> = (props) => {
  const selectionDetails = useSelectedConversationsDetails(props);
  const [isTicketStatusDropdownOpen, setIsTicketStatusDropdownOpen] = useState(false);
  const ticketStatusRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={ticketStatusRef}>
      <ConversationTicketStatusCoordinator
        cellsContext={props.cellsContext}
        conversations={props.conversations}
        placement="bottom-end"
        keyboardAction={KeyboardActionsEnum.ARCHIVE}
        renderButtonTooltip={() => <Trans id="inboxes-topbar-ticket-status">Change status</Trans>}
        renderButton={({isOpen, isDisabled}) => (
          <DropdownBox
            isDisabled={isDisabled}
            hasHover={isOpen}
            noInnerMargin
            noInputMarginRight
            value={<TicketStatusCell selectionDetails={selectionDetails} />}
          />
        )}
        isTicketStatusDropdownOpen={isTicketStatusDropdownOpen}
        onTicketStatusDropdownToggle={setIsTicketStatusDropdownOpen}
      />
      {ticketStatusRef.current && (
        <>
          <OpenStatusEducationTipCoordinator
            anchor={ticketStatusRef.current}
            conversationId={props.conversations[0]?.id}
          />
          <ResolvedStatusEducationTipCoordinator
            anchor={ticketStatusRef.current}
            conversationId={props.conversations[0]?.id}
          />
        </>
      )}
    </div>
  );
};
